import { useOnOutsideClick } from "client/hooks/utils/useOnOutsideClick";
import { useRef, useState } from "react";
import { ColorChangeHandler, SketchPicker } from "react-color";
export interface ColorInputProps {
    defaultColor?: string;
    handleChange?: (color: string) => void;
}

export const ColorInput = ({ defaultColor, handleChange }: ColorInputProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [color, setColor] = useState(defaultColor ?? "");

    const parentRef = useRef<HTMLDivElement>(null);
    useOnOutsideClick(parentRef, isOpen, () => {
        setIsOpen(false);
    });

    const onChange: ColorChangeHandler = (color) => {
        const value = color.hex;
        setColor(value);
        handleChange && handleChange(value);
    };

    return (
        <div className="flex items-center gap-3" ref={parentRef}>
            <div onClick={() => setIsOpen(true)} className="cursor-pointer" data-testid="color-value">
                {color.toUpperCase()}
            </div>
            <div
                style={{
                    backgroundColor: color,
                    height: 20,
                    width: 20,
                    borderRadius: 4,
                }}
                className="relative cursor-pointer"
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                {isOpen && (
                    <div className="absolute bottom-full right-full z-30 mb-4" onClick={(e) => e.stopPropagation()}>
                        <SketchPicker color={color} onChange={onChange} disableAlpha={true} />
                    </div>
                )}
            </div>
        </div>
    );
};

